import { render, staticRenderFns } from "./PcDataTable.vue?vue&type=template&id=faa39568"
import script from "./PcDataTable.vue?vue&type=script&lang=js"
export * from "./PcDataTable.vue?vue&type=script&lang=js"
import style0 from "./PcDataTable.vue?vue&type=style&index=0&id=faa39568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VIcon,VProgressCircular,VRow})
